<template>
    <div>
        <v-checkbox
        class="ma-0 pa-0"
        v-model="having_coupon"
        :label="$t('coupon_code.i_have')"
        color="primary"
        ></v-checkbox>
        <!-- Coupon form -->
        <v-form ref="couponForm" onsubmit="return false;">
            <v-layout row wrap v-if="having_coupon">
                <v-flex xs12 md9>
                    <v-text-field
                    outline
                    id="coupon"
                    color="secondary"
                    :label="$t('coupon_code')"
                    name="coupon"
                    type="text"
                    :rules="[rules.required, rules.exact_length(6), rules.alphaNumericCharacters]"
                    v-model="coupon_code"
                    :class="[$vuetify.rtl ? 'pl-2' : 'pr-2']"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-md-right">
                    <v-btn
                    color="primary background--text"
                    class="ma-0 pa-0 white--text"
                    @click.stop="redeemCoupon()"
                    >{{ $t("coupon_code.redeem") }}</v-btn>
                </v-flex>
            </v-layout>
        </v-form>
    </div>
</template>

<script>
import rules from "@/validation";
import { mapState } from "vuex";

export default {
    name:"CouponForm",

    data(){
        return{
            rules,
            having_coupon:false,
            coupon_code:null
        }
    },
    computed:{
        ...mapState({
            company: (state) => state.company.company,
        }),
    },
    watch:{
        having_coupon(){
            this.$emit("update:having_coupon",this.having_coupon)
        },
        coupon_code(){
            this.$emit("update:coupon_code",this.coupon_code)
        },

    },
    methods:{
        redeemCoupon() {
            this.$emit("redeem");
        },
        validate(){
            this.$emit("update:coupon_code",this.coupon_code)
            return this.$refs.couponForm.validate();
        },
        reset() {
            this.$refs.couponForm.reset();
            this.having_coupon = false;
            this.coupon_code = null;
        },
    }
}
</script>

<style>

</style>
